import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import TotalExperience from "../TotalExperience";

function AboutCard() {
  const yoy= TotalExperience();

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          Hello, I’m <span className="purple">Teekam Singh,</span> currently working at <span className="purple">Infosys Limited</span> with {yoy.years}+ years of experience, previously at Tata Consultancy Services (TCS), with strong hands-on expertise in React.js, Express.js, Node.js, MongoDB, and related web technologies.
            <br />
            <br />
            Apart from development, here are some other activities I love to do:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Blogging
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "True progress in technology is measured by how it elevates humanity."{" "}
          </p>
          <footer className="blockquote-footer">Anonymous</footer>
          {/* <footer className="blockquote-footer">Teekam Singh</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
